'use client';

import { jobListingSection } from '@stereoagency/sanity-schema';
import useSWR from 'swr';
import { useContext } from 'react';
import { jobsQuery } from './jobsQuery';
import JobListingSection from './JobListingSection.client';
import { SanityDraftClientContext } from '@/components/context';

type Props = Omit<
  typeof jobListingSection.schema.jobListingSection,
  '_type'
> & {};

export default function DraftModeJobListingSection({
  enableTaxonomyFilter
}: Props) {
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR('jobs', () =>
    client?.fetch<(typeof jobsQuery)[1]>(jobsQuery[0])
  );

  return (
    <JobListingSection
      enableTaxonomyFilter={enableTaxonomyFilter}
      jobs={data ?? []}
    />
  );
}
